export const communityTopics = [
  {
    id: "best-2026-autumn-anime",
    title: "2026 秋季新番，你心中的前三名是哪几部？",
    author: "追番小队长",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20cheerful%20girl%20with%20short%20teal%20hair%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-01&orientation=squarish",
    createdAt: "2 小时前",
    replies: 128,
    views: 3642,
    category: "新番讨论",
    content:
      "秋季档第一部完结在即，先开个楼收集大家的前三名。我个人目前是《星环彼岸》《夜行列车》《春日雨信》，理由写在下面，欢迎补充你的榜单和理由。",
    comments: [
      {
        id: "c1",
        author: "夜行动物",
        avatar:
          "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20calm%20boy%20with%20dark%20hair%20and%20glasses%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-02&orientation=squarish",
        time: "1 小时前",
        content: "《夜行列车》的叙事节奏太舒服了，每一集都像在看一部短篇小说。",
        replies: [
          { id: "c1-r1", author: "追番小队长", time: "52 分钟前", content: "同感，尤其是第七站的氛围处理。" }
        ]
      },
      {
        id: "c2",
        author: "机甲控老张",
        avatar:
          "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20friendly%20older%20man%20with%20grey%20hair%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-03&orientation=squarish",
        time: "1 小时前",
        content: "别忘了几部原创，今年的制作规格是真的高。",
        replies: []
      },
      {
        id: "c3",
        author: "雨信上头",
        avatar:
          "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20girl%20with%20long%20brown%20hair%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-04&orientation=squarish",
        time: "34 分钟前",
        content: "《春日雨信》每一集都能把人看哭，治愈系天花板。",
        replies: []
      }
    ]
  },
  {
    id: "magical-girl-recommendations",
    title: "求推荐！最近想补魔法少女题材的经典作品",
    author: "新入坑的猫",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20cute%20cat%20ear%20girl%20with%20pink%20hair%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-05&orientation=squarish",
    createdAt: "5 小时前",
    replies: 76,
    views: 2183,
    category: "动漫推荐讨论区",
    content:
      "刚看完今年的几部新作，想往前补一些经典。有没有适合新入坑、不那么黑的推荐？谢谢大家！",
    comments: [
      {
        id: "c1",
        author: "老观众一枚",
        time: "4 小时前",
        content: "可以先从九十年代的经典看起，再慢慢过渡到近年的作品。",
        replies: []
      },
      {
        id: "c2",
        author: "星屑礼赞厨",
        time: "3 小时前",
        content: "今年那部就很有代表性，温柔但不幼稚。",
        replies: [
          { id: "c2-r1", author: "新入坑的猫", time: "2 小时前", content: "收到，这就去补！" }
        ]
      }
    ]
  },
  {
    id: "animation-craft-behind-scenes",
    title: "聊聊那些让你起鸡皮疙瘩的作画名场面",
    author: "原画爱好者",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20focused%20young%20man%20with%20brown%20hair%20and%20a%20hoodie%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-06&orientation=squarish",
    createdAt: "昨天",
    replies: 94,
    views: 4120,
    category: "创作交流",
    content:
      "不限作品，说说那些你反复回看的作画片段，最好带上时间点，方便大家一起欣赏。",
    comments: [
      {
        id: "c1",
        author: "逐帧党",
        time: "20 小时前",
        content: "《破晓之刃》最终话的对决，节奏处理堪称教科书。",
        replies: []
      },
      {
        id: "c2",
        author: "摄影研习",
        time: "18 小时前",
        content: "其实很多冲击力来自摄影合成的镜头模糊，值得单独拆解。",
        replies: []
      }
    ]
  },
  {
    id: "mecha-recommendation-zone",
    title: "机甲讨论区：本季私心推荐征集",
    author: "铁翼",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20serious%20young%20man%20with%20silver%20hair%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-07&orientation=squarish",
    createdAt: "昨天",
    replies: 53,
    views: 1760,
    category: "机甲推荐讨论区",
    content:
      "老规矩，一人一部本季私心机甲推荐，附一句理由。拒绝吵架，友好安利。",
    comments: [
      {
        id: "c1",
        author: "钢之声",
        time: "昨天",
        content: "推荐一部人物驱动的作品，驾驶舱里的对手戏比战斗还好看。",
        replies: []
      }
    ]
  },
  {
    id: "share-your-desk-setup",
    title: "晒晒你的追番角落：桌面/房间布置交流",
    author: "宅家布置小组",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20cozy%20girl%20with%20orange%20hair%20and%20a%20sweater%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20character%20icon&width=200&height=200&seq=av-08&orientation=squarish",
    createdAt: "2 天前",
    replies: 41,
    views: 1290,
    category: "闲聊灌水",
    content:
      "欢迎分享自己的追番环境，手办、海报、灯光都可以，一起找找布置灵感。",
    comments: [
      {
        id: "c1",
        author: "暖光控",
        time: "2 天前",
        content: "暖黄色的灯真的会让整个空间舒服很多。",
        replies: []
      }
    ]
  },
  {
    id: "site-update-announcement",
    title: "【公告】漫蛙2 站内功能更新说明",
    author: "漫蛙2 管理组",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20friendly%20mascot%20frog%20character%20with%20orange%20scarf%2C%20cel%20shaded%2C%20soft%20gradient%20background%2C%20simple%20clean%20icon&width=200&height=200&seq=av-09&orientation=squarish",
    createdAt: "3 天前",
    replies: 12,
    views: 860,
    category: "站务公告",
    content:
      "本次更新新增角色首字母索引、更新列表排序与全站搜索。欢迎体验并提出建议。",
    comments: [
      {
        id: "c1",
        author: "热心用户",
        time: "3 天前",
        content: "首字母索引好用，找角色快多了。",
        replies: []
      }
    ]
  }
];